import React from "react";
import Banner from "./Banner";

const BannerDesktop = React.memo(({ isDisplayed }) => {
  return <Banner isDisplayed={isDisplayed} />;
});
export default BannerDesktop;
